// src/components/dashboard/ClientEmailPanel.tsx
import type { BookingJob } from '@/lib/types/workflow';
import { formatSASTTime } from '@/lib/utils/date';
import { brand, fonts, styles } from '@/lib/tokens';

type Props = { booking: BookingJob };

export function ClientEmailPanel({ booking }: Props) {
  const paragraphs = booking.emailBody.split(/\n\n+/);

  return (
    <section
      className="flex flex-col overflow-hidden panel-col"
      style={{
        display: 'flex',
        flexDirection: 'column',
        borderRight: `1px solid ${brand.hairlineSoft}`,
        overflow: 'hidden',
      }}
    >
      {/* Panel header */}
      <div className="panel-header">Client Email</div>

      {/* Scrollable content */}
      <div
        className="custom-scroll"
        style={{ flex: 1, overflowY: 'auto', padding: 20 }}
      >
        <div
          className="glass-surface card-border"
          style={{ padding: 20, borderRadius: 12 }}
        >
          {/* Sender row */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              marginBottom: 16,
            }}
          >
            <span
              style={{
                fontFamily: fonts.sans,
                fontSize: 14,
                fontWeight: 600,
                color: brand.onSurface,
              }}
            >
              {booking.clientName}
            </span>
            <span
              style={{
                ...styles.monoLabel,
                letterSpacing: '0.06em',
                whiteSpace: 'nowrap',
              }}
            >
              {formatSASTTime(booking.receivedAt)}
            </span>
          </div>

          {/* Email body */}
          <div
            className="custom-scroll"
            style={{
              fontFamily: fonts.sans,
              fontSize: 14,
              lineHeight: 1.7,
              color: brand.onSurfaceVariant,
            }}
          >
            {paragraphs.map((p, i) => (
              <p
                key={i}
                style={{
                  marginBottom: i === paragraphs.length - 1 ? 0 : 12,
                  whiteSpace: 'pre-wrap',
                }}
              >
                {p}
              </p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
